
import * as React from "react";
import {Row } from 'antd';
import ReactECharts from 'echarts-for-react';
import { assert_key } from "../../../helper";

export interface IProps {
    acc_package:any
}
export interface IState {
}

export default class AccuracyChart extends React.Component<IProps, IState>{
    public refresh_number: any = 1;
    constructor(props:IProps) {
        super(props);
        this.renderAccuracyChart = this.renderAccuracyChart.bind(this);
        this.state = {
        }
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }
    public renderAccuracyChart = (acc_package_dict:any) => {
      // acc_package: year(x), acc(y)
      let selected_api_list = Object.keys(acc_package_dict);
      let x_axis_data:any = [];
      let y_series_data:any = [];
      let whole_value_min = 1;
      let whole_value_max = 0;
      let enable_accuracy_chart = true;
      this.refresh_number = this.refresh_number + 1;
      for(let i = 0; i<selected_api_list.length; i++){
        let selected_api = selected_api_list[i];
        let acc_package = acc_package_dict[selected_api];
        let flag = assert_key(acc_package, ["year","value"]);
        if(!flag){
          enable_accuracy_chart = false;
          break;
        }
        if(i == 0){
          x_axis_data = acc_package["year"];
        }
        let value_min = Math.min(...acc_package["value"]);
        let value_max = Math.max(...acc_package["value"]);
        
        whole_value_min = Math.min(value_min, whole_value_min);
        whole_value_max = Math.max(value_max, whole_value_max);

        let single_data_package = {
          "data": acc_package["value"],
          "type": "line",
          "name": selected_api
        }
        y_series_data.push(single_data_package)
      }
      console.log("y_series_data", y_series_data);
      whole_value_max = Math.floor((parseFloat(whole_value_max.toFixed(2))+0.01)*100)/100;
      whole_value_min =Math.floor((parseFloat(whole_value_min.toFixed(2))-0.01)*100)/100;
      if(whole_value_max<whole_value_min) whole_value_max = whole_value_min;
      let accuracy_chart_option = {};
      
      
            
      if(enable_accuracy_chart){
          
          

          accuracy_chart_option = {
              title: {
                 // text: 'Accuracy'
                },
                tooltip: {
                  formatter: function (params:any) {
                    //console.log("tooltip", params);
                    return params["marker"] + params["name"] + "&nbsp;&nbsp;&nbsp;&nbsp;<strong>"+ params["data"].toFixed(3)+"</strong>";
                  }
                },
                grid:{
                  "left": "50",
                  "right": "50"
                },

                
                legend: {
                  right: '50',
                  
                },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: x_axis_data,
                
              },
              yAxis: {
                type: 'value',
                min: whole_value_min,
                max: whole_value_max
              },
              series: y_series_data,
              notMerge: true
            };     
          return <ReactECharts key={this.refresh_number} option={accuracy_chart_option} />
      }else{
          return <div />
      }
  }
    public renderAccuracyChart_SinglePackage = (acc_package:any) => {
        // acc_package: year(x), acc(y)
        let flag = assert_key(acc_package, ["year","value"]);
        let enable_accuracy_chart = flag;
        let accuracy_chart_option = {};
        
        
              
        if(enable_accuracy_chart){
            
            let value_min = Math.min(...acc_package["value"]);
            let value_max = Math.max(...acc_package["value"]);
            value_max = parseFloat(value_max.toFixed(2))+0.01;
            value_min = parseFloat(value_min.toFixed(2))-0.01;
            if(value_max<value_min) value_max = value_min;

            accuracy_chart_option = {
                title: {
                    text: 'Accuracy'
                  },
                  tooltip: {},
                xAxis: {
                  type: 'category',
                  boundaryGap: false,
                  data: acc_package["year"],
                  
                },
                yAxis: {
                  type: 'value',
                  min: value_min,
                  max: value_max
                },
                series: [
                  {
                    data: acc_package["value"],
                    type: 'line'
                  }
                ]
              };     
            return <ReactECharts option={accuracy_chart_option} />
        }else{
            return <div />
        }
    }
    

    public render() {

        return this.renderAccuracyChart(this.props.acc_package);
    }
}